import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import { useStorageState } from 'just-storage-hooks';
import {
	makeStyles, Button, Tabs, Tab, Toolbar, MenuItem, Select,
	FormControl, InputLabel, List, ListItem, ListItemText,
} from '@material-ui/core';
import useFirebase, { useFirestoreCollectionRT } from '../hooks/firebase';
import FirebaseInput from './FirebaseInput';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		padding: theme.spacing(1),
		minHeight: 400,
	},
	tabs: {
		borderRight: `1px solid ${theme.palette.divider}`,
	},
	content: {
		flex: '100% 1 1',
	},
	toolbar: {
		display: 'flex',
		flexDirection: 'row',
		'& > *': {
			flex: '100%',
			margin: theme.spacing(1),
		},
	},
	listItem: {
		'& > *': {
			// flex: '100%',
			margin: theme.spacing(1),
		},
	},
	actions: {
		'& > *': {
			margin: theme.spacing(1),
		},
	},
}));

export const boardTypeMap = {
	'1up': [
		{ label: 'Main', key: 'screen0', player: 'player0' },
	],
	'1p1': [
		{ label: 'Main', key: 'screen0', player: 'player0' },
		{ label: 'Secondary', key: 'screen1' },
	],
	'2up': [
		{ label: 'Left', key: 'screen0', player: 'player0' },
		{ label: 'Right', key: 'screen1', player: 'player1' },
	],
	'2p1': [
		{ label: 'Left', key: 'screen0', player: 'player0' },
		{ label: 'Right', key: 'screen1', player: 'player1' },
		{ label: 'Bottom', key: 'screen2' },
	],
	// '1po': [
	// 	{ label: 'Main', key: 'screen0' },
	// 	{ label: 'Secondary', key: 'screen1' },
	// ],
	// '1p2': [
	// 	{ label: 'Main', key: 'screen0' },
	// 	{ label: 'Secondary Left', key: 'screen1' },
	// 	{ label: 'Secondary Right', key: 'screen2' },
	// ],
};

function boardSort([a], [b]) {
	return a.padStart(a.length, '0') > b.padStart(b.length, '0') ? 1 : -1;
}

export default function AdminBoards(props) {
	const { className } = props;
	const classes = useStyles();

	const { firestore } = useFirebase();
	const boards = useFirestoreCollectionRT('boards');

	const [selectedId, setSelectedId] = useStorageState('adminBoardSelectedId');
	const selectedBoard = boards ? boards[selectedId] : undefined;
	const boardOptions = boardTypeMap[selectedBoard?.type];

	const handleAdd = () => {
		const boardId = prompt('board id');
		if (!boardId) return;

		const ref = firestore.doc(`boards/${boardId}`);
		ref.set({
			name: boardId,
		}, { merge: true }).catch(console.log);
		setSelectedId(boardId);
	};

	const handleTypeChange = ({ target }) => {
		const ref = firestore.doc(`boards/${selectedId}`);
		ref.set({
			type: target.value,
		}, { merge: true }).catch(console.log);
	};

	const handleAction = (type) => {
		const ref = firestore.doc(`boards/${selectedId}`);
		ref.set({
			[type]: Date.now(),
		}, { merge: true }).catch(console.error);
	};

	return (
		<div className={clsx(classes.root, className)}>
			<Tabs
				orientation="vertical"
				variant="scrollable"
				value={selectedId}
				onChange={(_, value) => setSelectedId(value)}
				className={classes.tabs}
			>
				{boards && Object.entries(boards).sort(boardSort).map(([boardId, board]) => (
					<Tab value={boardId} label={board.name || boardId} />
				))}
				<Button onClick={handleAdd}>Add&nbsp;Board</Button>
			</Tabs>
			<div
				className={classes.content}
			>
				{selectedBoard && (
					<>
						<Toolbar className={classes.toolbar}>
							<span>{`Id: ${selectedId}`}</span>
							<FirebaseInput
								className={classes.margin}
								label="Name"
								doc={selectedBoard}
								docPath={`boards/${selectedId}`}
								docKey="name"
							/>
							<FormControl>
								<InputLabel>Board Type</InputLabel>
								<Select
									value={selectedBoard.type || ''}
									onChange={handleTypeChange}
								>
									{Object.keys(boardTypeMap).map((type) => (
										<MenuItem value={type}>{type}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Toolbar>
						<List>
							{boardOptions && boardOptions.map((option) => (
								<ListItem className={classes.listItem}>
									<ListItemText primary={option.label} />
									{option.player && (
										<FirebaseInput
											className={classes.margin}
											label="Player Name"
											doc={selectedBoard}
											docPath={`boards/${selectedId}`}
											docKey={option.player}
										/>
									)}
									<FirebaseInput
										className={classes.margin}
										label="Screen Ratio(16x9)"
										doc={selectedBoard}
										docPath={`boards/${selectedId}`}
										docKey={option.key}
									/>
								</ListItem>
							))}
						</List>
						<div
							className={classes.actions}
						>
							<Button
								variant="contained"
								color="primary"
								onClick={() => handleAction('firework')}
							>
								Firework
							</Button>
							<Button
								variant="contained"
								color="primary"
								onClick={() => handleAction('toasty')}
							>
								Toasty
							</Button>
							<Button
								variant="contained"
								color="secondary"
								onClick={() => handleAction('refresh')}
							>
								Refresh
							</Button>
						</div>
					</>
				)}
			</div>
		</div>
	);
}

AdminBoards.defaultProps = {
	className: undefined,
};

AdminBoards.propTypes = {
	className: propTypes.string,
};
